export const REPORTS_V2_FLAG = 'release-AHA2-402-reports-v2'

export const REPORTS_V2_VARIANTS = {
  TREATMENT: 'treatment',
}
